import { useId } from '@/hooks';
import { type FC, useRef } from 'react';
import { ProjectLedgerContent } from '../_components/ProjectLedgerContent';
import { ProjectLedgerPageLayout } from '../_components/ProjectLedgerPageLayout';
import { useProjectLedgerData } from '../_hooks/useProjectLedgerData';
import { useProjectLedgerPagePrint } from '../_hooks/useProjectLedgerPrintUtils';

/**
 * 帳票ページ
 * ページヘッダーとPDF出力機能を提供
 */
export const ProjectLedgerPage: FC = () => {
  const { id } = useId();
  const contentRef = useRef<HTMLDivElement>(null);

  // データ取得
  const ledgerData = useProjectLedgerData(id);
  const { project, ministryName } = ledgerData || {};

  // 印刷機能（タイトル設定、ブラウザタブ更新、印刷処理、最終出力日時更新を統合）
  const { handlePrintPdf } = useProjectLedgerPagePrint({
    contentRef,
    project,
    ministryName,
    projectId: id,
  });

  return (
    <ProjectLedgerPageLayout onPrintPdf={handlePrintPdf}>
      <div ref={contentRef}>
        <ProjectLedgerContent projectId={id} ledgerData={ledgerData} />
      </div>
    </ProjectLedgerPageLayout>
  );
};
